"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootDetailSagas = void 0;
var ResultItemSaga_1 = require("@/pages/search/sagas/ResultItemSaga");
var EnquireAction_1 = require("@/pages/common/actions/EnquireAction");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var RootPublicPageSaga_1 = require("@/pages/common/sagas/RootPublicPageSaga");
var RootTrendsSaga_1 = require("@/pages/common/sagas/RootTrendsSaga");
var RootTransactionsSaga_1 = require("@/pages/common/sagas/RootTransactionsSaga");
var NearbymapState_1 = require("@/pages/common/states/NearbymapState");
var DetailAction_1 = require("@/pages/detail/actions/DetailAction");
var DetailGalleryAction_1 = require("@/pages/detail/actions/DetailGalleryAction");
var DetailGallerySaga_1 = require("@/pages/detail/sagas/DetailGallerySaga");
var NearbyCallSaga_1 = require("@/pages/detail/sagas/NearbyCallSaga");
var NearbySaga_1 = require("@/pages/detail/sagas/NearbySaga");
var DetailGalleryState_1 = require("@/pages/detail/states/DetailGalleryState");
var DetailPopNearbyTabType_1 = require("@/pages/detail/states/DetailPopNearbyTabType");
var DetailPopTabType_1 = require("@/pages/detail/states/DetailPopTabType");
var PlaceAvailableSaga_1 = require("@/pages/place/sagas/PlaceAvailableSaga");
var PlaceSaga_1 = require("@/pages/place/sagas/PlaceSaga");
var effects_1 = require("redux-saga/effects");
var NearbyAction_1 = require("../actions/NearbyAction");
var MortgageSagas_1 = require("./MortgageSagas");
var LayoutAction_1 = require("@/pages/common/actions/LayoutAction");
var WindowApi_1 = require("@/api/browser/WindowApi");
var stateFilter_1 = require("@/pages/common/sagas/stateFilter");
var SignupAction_1 = require("@/pages/common/actions/SignupAction");
var SaveSearchDialogSaga_1 = require("@/pages/search/sagas/SaveSearchDialogSaga");
var VideoSaga_1 = require("@/pages/detail/sagas/VideoSaga");
var searchQueryToSaveSearchSet_1 = require("@/transformers/searchQueryToSaveSearchSet");
var DetailCallSaga_1 = require("@/pages/detail/sagas/DetailCallSaga");
var SaveSearchApiSaga_1 = require("@/pages/search/sagas/api/SaveSearchApiSaga");
var UserAction_1 = require("@/pages/common/actions/UserAction");
var VideoSagaSelector_1 = require("@/pages/detail/sagas/VideoSagaSelector");
var UserPropertiesCrud_1 = require("@/pages/saveproperties/sagas/UserPropertiesCrud");
var BigPopupState_1 = require("@/pages/common/states/BigPopupState");
var GlobalCallSaga_1 = require("@/pages/common/sagas/GlobalCallSaga");
var ShareAction_1 = require("@/pages/common/actions/ShareAction");
var getCurrentSort = function (state) {
    return state.detail.similar.currentSort;
};
var getCurrentOrder = function (state) {
    return state.detail.similar.currentOrder;
};
var getGallery = function (state) { return state.detail.gallery; };
var getPropertyPhotoGallery = function (state) {
    return state.detail.galleryPhotos;
};
var getFloorPlanGallery = function (state) {
    return state.detail.galleryFloorPlans;
};
var getCurrentPopupTab = function (state) {
    return state.detail.popActiveTab;
};
var getProperty = function (state) { return state.detail.property; };
var getHasVr = function (state) {
    return state.detail.gallery.items.find(function (it) { return it.type === DetailGalleryState_1.DetailGalleryItemType.VR; });
};
var getSaveSearchBuildingId = function (state) {
    return state.detail.buildingFollowingId;
};
var getSaveSearchDistrictId = function (state) {
    return state.detail.districtFollowingId;
};
var getIsMortgageExpand = function (state) {
    return state.detail.isMortgageExpand;
};
var getIsNearbyMore = function (state) {
    return state.detail.nearbyMap.big.popNearbyMore;
};
var getIsNearbyMapIsVisible = function (scrolled) {
    var element = document.getElementById('detail-smallmap');
    if (!element)
        return null;
    return element.offsetTop < scrolled + window.innerHeight;
};
var getPropertyShareUrl = function (state) { return state.share.url; };
var getPropertyTitle = function (state) { return state.detail.property.building; };
var getPropertyText = function (state) { return state.detail.property.description; };
var getSomePropertyPhotos = function (state) {
    return state.detail.galleryPhotos.items.filter(function (it) { return it.type === DetailGalleryState_1.DetailGalleryItemType.IMAGE; })
        .map(function (it) { return it.src; }).slice(0, 1);
};
var sortToggleSaga = PlaceSaga_1.watchSortToggle(getCurrentSort, getCurrentOrder);
var detailGallerySaga = DetailGallerySaga_1.initDetailGallerySaga(getGallery);
var detailPropertyPhotoGallerySaga = DetailGallerySaga_1.initDetailGallerySaga(getPropertyPhotoGallery);
var detailFloorPlanGallerySaga = DetailGallerySaga_1.initDetailGallerySaga(getFloorPlanGallery);
var setWatchStickyContact = function () {
    var action, scrolled, stickyTop;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_WINDOW_SCROLL)];
            case 1:
                action = _a.sent();
                scrolled = action.payload;
                return [4 /*yield*/, effects_1.call(WindowApi_1.getStickyTop, 'enquireContactButton')];
            case 2:
                stickyTop = _a.sent();
                if (stickyTop === null)
                    return [2 /*return*/];
                if (!(scrolled > stickyTop)) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.put(DetailAction_1.default.setStickyContact(true))];
            case 3:
                _a.sent();
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, effects_1.put(DetailAction_1.default.setStickyContact(false))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [3 /*break*/, 0];
            case 7: return [2 /*return*/];
        }
    });
};
var setWatchStickyTop = function () {
    var action, scrolled, stickyTop;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_WINDOW_SCROLL)];
            case 1:
                action = _a.sent();
                scrolled = action.payload;
                return [4 /*yield*/, effects_1.call(WindowApi_1.getStickyTop, 'sticky1')];
            case 2:
                stickyTop = _a.sent();
                if (stickyTop === null)
                    return [2 /*return*/];
                if (!(scrolled > stickyTop)) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.put(DetailAction_1.default.setSticky(true))];
            case 3:
                _a.sent();
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, effects_1.put(DetailAction_1.default.setSticky(false))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [3 /*break*/, 0];
            case 7: return [2 /*return*/];
        }
    });
};
var setFollowState = function (user) {
    var state, name, buildingFollowingId, districtFollowingId;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!!user.email) return [3 /*break*/, 2];
                return [4 /*yield*/, effects_1.put(DetailAction_1.default.setBuildingFollowingId(-1))];
            case 1:
                _a.sent();
                return [2 /*return*/];
            case 2: return [4 /*yield*/, effects_1.select()];
            case 3:
                state = _a.sent();
                name = state.detail.property.building;
                return [4 /*yield*/, effects_1.call(DetailCallSaga_1.getBuildingFollowState, name, state.detail.referringType)];
            case 4:
                buildingFollowingId = _a.sent();
                if (!buildingFollowingId) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.put(DetailAction_1.default.setBuildingFollowingId(buildingFollowingId))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [4 /*yield*/, effects_1.call(DetailCallSaga_1.getDistrictFollowState, state.detail.district.id)];
            case 7:
                districtFollowingId = _a.sent();
                if (!districtFollowingId) return [3 /*break*/, 9];
                return [4 /*yield*/, effects_1.put(DetailAction_1.default.setDistrictFollowingId(districtFollowingId))];
            case 8:
                _a.sent();
                _a.label = 9;
            case 9: return [2 /*return*/];
        }
    });
};
var setEnquireCurrent = function () {
    var item;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(getProperty)];
            case 1:
                item = _a.sent();
                return [4 /*yield*/, effects_1.put(EnquireAction_1.default.setCurrent(item))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var setRecentlyViewed = function () {
    var item;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(getProperty)];
            case 1:
                item = _a.sent();
                return [4 /*yield*/, effects_1.call(UserPropertiesCrud_1.addRecentlyViewed, [item])];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchClosePopup = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(DetailAction_1.default.DETAIL_CLOSE_POPUP)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setNearbyMore(false))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(DetailAction_1.default.setPopActive(DetailPopTabType_1.DetailPopTabType.NONE))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.delay(100)];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.put(DetailAction_1.default.setPopRender(false))];
            case 5:
                _a.sent();
                return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
var watchGalleryGridItemClick = function () {
    var payload, photo, id, i;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(DetailAction_1.default.DETAIL_POPUP_GRID_IMAGE_CLICK)];
            case 1:
                payload = (_a.sent()).payload;
                photo = payload.photo;
                id = payload.id;
                i = payload.i;
                return [4 /*yield*/, effects_1.put(DetailGalleryAction_1.default.setGalleryIndex(id, i, true))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchPopupMenuItemClick = function () {
    var payload, type, hasVr;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.take(DetailAction_1.default.DETAIL_POPUP_MENUITEM_CLICK)];
            case 1:
                payload = (_a.sent()).payload;
                type = payload;
                return [4 /*yield*/, effects_1.select(getHasVr)];
            case 2:
                hasVr = _a.sent();
                if (type === DetailPopTabType_1.DetailPopTabType.VR && !hasVr) {
                    return [3 /*break*/, 0];
                }
                return [4 /*yield*/, effects_1.put(DetailAction_1.default.setPopActive(type))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setNearbyMore(false))];
            case 4:
                _a.sent();
                if (!(type === DetailPopTabType_1.DetailPopTabType.NEARBY)) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.delay(300)];
            case 5:
                _a.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.onFilterClick(DetailPopNearbyTabType_1.DetailPopNearbyTabType.PROPERTIES))];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7: return [3 /*break*/, 0];
            case 8: return [2 /*return*/];
        }
    });
};
var watchVrClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(DetailAction_1.default.DETAIL_VR_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(DetailAction_1.default.setPopRender(true))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(DetailAction_1.default.setPopActive(DetailPopTabType_1.DetailPopTabType.VR))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchNearbyClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(DetailAction_1.default.DETAIL_NEARBY_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(DetailAction_1.default.setPopRender(true))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(DetailAction_1.default.setPopActive(DetailPopTabType_1.DetailPopTabType.NEARBY))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.delay(300)];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.onFilterClick(DetailPopNearbyTabType_1.DetailPopNearbyTabType.SCHOOL))];
            case 5:
                _a.sent();
                return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
var watchMyPlaceClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(DetailAction_1.default.DETAIL_MYPLACE_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(DetailAction_1.default.setPopRender(true))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(DetailAction_1.default.setPopActive(DetailPopTabType_1.DetailPopTabType.NEARBY))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.delay(300)];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.onFilterClick(DetailPopNearbyTabType_1.DetailPopNearbyTabType.MYPLACE))];
            case 5:
                _a.sent();
                return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
var watchPropertyClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(DetailAction_1.default.DETAIL_PROPERTY_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(DetailAction_1.default.setPopRender(true))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(DetailAction_1.default.setPopActive(DetailPopTabType_1.DetailPopTabType.NEARBY))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.delay(300)];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.onFilterClick(DetailPopNearbyTabType_1.DetailPopNearbyTabType.PROPERTIES))];
            case 5:
                _a.sent();
                return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
var watchPopRender = function () {
    var payload, tab;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 2];
                return [4 /*yield*/, effects_1.take(DetailAction_1.default.DETAIL_SET_POP_ACTIVE_TAB)];
            case 1:
                payload = (_a.sent()).payload;
                tab = payload;
                if (tab !== DetailPopTabType_1.DetailPopTabType.NEARBY)
                    return [3 /*break*/, 0];
                return [3 /*break*/, 0];
            case 2: return [2 /*return*/];
        }
    });
};
var setOnScrollInitSmallMap = function () {
    var shouldListenToScroll, _loop_1, state_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                shouldListenToScroll = true;
                _loop_1 = function () {
                    var action, scrolled, isMapVisible, filter, propertyCenter, propertyName, results, icon_1, mapObjects, propertyPin;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_WINDOW_SCROLL)];
                            case 1:
                                action = _a.sent();
                                scrolled = action.payload;
                                return [4 /*yield*/, effects_1.call(getIsNearbyMapIsVisible, scrolled)];
                            case 2:
                                isMapVisible = _a.sent();
                                if (isMapVisible === null)
                                    return [2 /*return*/, { value: void 0 }];
                                if (!isMapVisible) return [3 /*break*/, 10];
                                shouldListenToScroll = false;
                                filter = DetailPopNearbyTabType_1.DetailPopNearbyTabType.SCHOOL;
                                return [4 /*yield*/, effects_1.select(NearbyCallSaga_1.getPropertyPosition)];
                            case 3:
                                propertyCenter = _a.sent();
                                return [4 /*yield*/, effects_1.select(NearbyCallSaga_1.getPropertyName)];
                            case 4:
                                propertyName = _a.sent();
                                return [4 /*yield*/, effects_1.call(NearbyCallSaga_1.getFilterResults, filter, propertyCenter)];
                            case 5:
                                results = _a.sent();
                                return [4 /*yield*/, effects_1.call(NearbyCallSaga_1.typeToPinStyle, filter)];
                            case 6:
                                icon_1 = _a.sent();
                                mapObjects = results.map(function (it) { return ({
                                    icon: icon_1,
                                    kind: NearbymapState_1.NearbymapObjectKind.MARKER,
                                    center: it.position,
                                    active: true,
                                }); });
                                propertyPin = {
                                    kind: NearbymapState_1.NearbymapObjectKind.PIN,
                                    center: propertyCenter,
                                    title: propertyName,
                                };
                                mapObjects.push(propertyPin);
                                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setSmallMapObjects(mapObjects))];
                            case 7:
                                _a.sent();
                                return [4 /*yield*/, effects_1.delay(300)];
                            case 8:
                                _a.sent();
                                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setSmallMapZoom(-2, propertyCenter))];
                            case 9:
                                _a.sent();
                                _a.label = 10;
                            case 10: return [2 /*return*/];
                        }
                    });
                };
                _a.label = 1;
            case 1:
                if (!shouldListenToScroll) return [3 /*break*/, 3];
                return [5 /*yield**/, _loop_1()];
            case 2:
                state_1 = _a.sent();
                if (typeof state_1 === "object")
                    return [2 /*return*/, state_1.value];
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/];
        }
    });
};
var watchEnquireClick = function () {
    var item;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(DetailAction_1.default.DETAIL_ON_ENQUIRE_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getProperty)];
            case 2:
                item = _a.sent();
                return [4 /*yield*/, effects_1.put(EnquireAction_1.default.onEnquireClick(item))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchWhatsAppClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(DetailAction_1.default.DETAIL_ON_WHATSAPP_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(DetailAction_1.default.onEnquireClick())];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchLayoutEnquireClick = function () {
    var payload, item;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(LayoutAction_1.default.ON_CONTACT_CLICKED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.take(EnquireAction_1.default.SET_CURRENT_ENQUIRE)];
            case 2:
                payload = (_a.sent()).payload;
                if (!!payload) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.select(getProperty)];
            case 3:
                item = _a.sent();
                return [4 /*yield*/, effects_1.put(EnquireAction_1.default.setCurrent(item))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
var watchLayoutWhatsAppClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(LayoutAction_1.default.ON_WHATSAPP_CLICKED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(DetailAction_1.default.onWhatsAppClick())];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchBackClick = function () {
    var tab, isMortgageExpand, isNearbyMore;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 12];
                return [4 /*yield*/, effects_1.take(DetailAction_1.default.DETAIL_ON_BACK_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentPopupTab)];
            case 2:
                tab = _a.sent();
                return [4 /*yield*/, effects_1.select(getIsMortgageExpand)];
            case 3:
                isMortgageExpand = _a.sent();
                return [4 /*yield*/, effects_1.select(getIsNearbyMore)];
            case 4:
                isNearbyMore = _a.sent();
                if (!isMortgageExpand) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.put(DetailAction_1.default.onExpandClick(false))];
            case 5:
                _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.scrollToMortgageCalculatorTop)];
            case 6:
                _a.sent();
                return [3 /*break*/, 11];
            case 7:
                if (!isNearbyMore) return [3 /*break*/, 9];
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setNearbyMore(false))];
            case 8:
                _a.sent();
                return [3 /*break*/, 11];
            case 9: return [4 /*yield*/, effects_1.put(DetailAction_1.default.closePopup())];
            case 10:
                _a.sent();
                _a.label = 11;
            case 11: return [3 /*break*/, 0];
            case 12: return [2 /*return*/];
        }
    });
};
var watchOnFavClick = function () {
    var item, isSaved, isDeleted;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 13];
                return [4 /*yield*/, effects_1.take(DetailAction_1.default.DETAIL_ON_FAV_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setLastSavedProperty(null))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getProperty)];
            case 3:
                item = _a.sent();
                if (!!item.isSaved) return [3 /*break*/, 9];
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setLastSavedProperty(item))];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.call(UserPropertiesCrud_1.addSavedProperties, [item])];
            case 5:
                isSaved = _a.sent();
                if (!isSaved) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.put(DetailAction_1.default.setIsSaved(true))];
            case 6:
                _a.sent();
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setBigPopupLocalized('save_property_success', BigPopupState_1.BigPopupType.SUCCESS, 'success', 'sucessSaveProperty'))];
            case 7:
                _a.sent();
                _a.label = 8;
            case 8: return [3 /*break*/, 12];
            case 9: return [4 /*yield*/, effects_1.call(UserPropertiesCrud_1.deleteSavedProperties, [Number(item.referenceId)])];
            case 10:
                isDeleted = _a.sent();
                if (!isDeleted) return [3 /*break*/, 12];
                return [4 /*yield*/, effects_1.put(DetailAction_1.default.setIsSaved(false))];
            case 11:
                _a.sent();
                _a.label = 12;
            case 12: return [3 /*break*/, 0];
            case 13: return [2 /*return*/];
        }
    });
};
var setIsSaved = function () {
    var item, savedPropertyIds;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(getProperty)];
            case 1:
                item = _a.sent();
                return [4 /*yield*/, effects_1.call(UserPropertiesCrud_1.getSavedPropertyIds)];
            case 2:
                savedPropertyIds = _a.sent();
                return [4 /*yield*/, effects_1.put(DetailAction_1.default.setIsSaved(savedPropertyIds.indexOf(Number(item.referenceId)) >= 0))];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchBuildingFollowClicked = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(DetailAction_1.default.DETAIL_ON_BUILDING_FOLLOW_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(DetailAction_1.default.onSaveBuidling())];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchDistrictFollowClicked = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(DetailAction_1.default.DETAIL_ON_DISTRICT_FOLLOW_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(DetailAction_1.default.onSaveDistrict())];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchDistrictUnfollowClicked = function () {
    var saveSearchId, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(DetailAction_1.default.DETAIL_ON_DISTRICT_UNFOLLOW_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getSaveSearchDistrictId)];
            case 2:
                saveSearchId = _a.sent();
                return [4 /*yield*/, effects_1.call(SaveSearchApiSaga_1.removeSaveSearchApi, saveSearchId)];
            case 3:
                response = _a.sent();
                if (!(response && !response.data.hasError)) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.put(DetailAction_1.default.setDistrictFollowingId(-1))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
var watchBuildingUnfollowClicked = function () {
    var saveSearchId, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(DetailAction_1.default.DETAIL_ON_BUILDING_UNFOLLOW_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getSaveSearchBuildingId)];
            case 2:
                saveSearchId = _a.sent();
                return [4 /*yield*/, effects_1.call(SaveSearchApiSaga_1.removeSaveSearchApi, saveSearchId)];
            case 3:
                response = _a.sent();
                if (!(response && !response.data.hasError)) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.put(DetailAction_1.default.setBuildingFollowingId(-1))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
var watchOnSaveDistrictSaga = function () {
    var isGuest, state, name, searchQuery, saveSearchSet, existingSearchSetId;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 14];
                return [4 /*yield*/, effects_1.take(DetailAction_1.default.DETAIL_ON_SAVE_DISTRICT)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.isUserGuest)];
            case 2:
                isGuest = _a.sent();
                if (!isGuest) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.put(SignupAction_1.default.setPanelDim(true))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.delay(100)];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.put(SignupAction_1.default.setPanelActive(true))];
            case 5:
                _a.sent();
                return [3 /*break*/, 13];
            case 6: return [4 /*yield*/, effects_1.select()];
            case 7:
                state = _a.sent();
                name = state.detail.district.name;
                return [4 /*yield*/, effects_1.call(DetailCallSaga_1.detailStateToSearchQueryForDistrict, state)];
            case 8:
                searchQuery = _a.sent();
                return [4 /*yield*/, effects_1.call(searchQueryToSaveSearchSet_1.searchQueryToSaveSearchSet, searchQuery, name)];
            case 9:
                saveSearchSet = _a.sent();
                saveSearchSet.languageId = state.layout.language.current;
                saveSearchSet.currencyId = state.layout.currencies.currentCurrencyId;
                return [4 /*yield*/, effects_1.call(SaveSearchDialogSaga_1.saveSearchSetToRemote, saveSearchSet)];
            case 10:
                _a.sent();
                return [4 /*yield*/, effects_1.call(DetailCallSaga_1.getDistrictFollowState, state.detail.district.id)];
            case 11:
                existingSearchSetId = _a.sent();
                if (!existingSearchSetId) return [3 /*break*/, 13];
                return [4 /*yield*/, effects_1.put(DetailAction_1.default.setDistrictFollowingId(existingSearchSetId))];
            case 12:
                _a.sent();
                _a.label = 13;
            case 13: return [3 /*break*/, 0];
            case 14: return [2 /*return*/];
        }
    });
};
var watchOnSaveBuildingSaga = function () {
    var isGuest, state, name, searchQuery, saveSearchSet, existingSearchSetId;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 14];
                return [4 /*yield*/, effects_1.take(DetailAction_1.default.DETAIL_ON_SAVE_BUILDING)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.isUserGuest)];
            case 2:
                isGuest = _a.sent();
                if (!isGuest) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.put(SignupAction_1.default.setPanelDim(true))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.delay(100)];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.put(SignupAction_1.default.setPanelActive(true))];
            case 5:
                _a.sent();
                return [3 /*break*/, 13];
            case 6: return [4 /*yield*/, effects_1.select()];
            case 7:
                state = _a.sent();
                name = state.detail.property.building;
                return [4 /*yield*/, effects_1.call(DetailCallSaga_1.detailStateToSearchQueryForBuilding, state)];
            case 8:
                searchQuery = _a.sent();
                return [4 /*yield*/, effects_1.call(searchQueryToSaveSearchSet_1.searchQueryToSaveSearchSet, searchQuery, name)];
            case 9:
                saveSearchSet = _a.sent();
                saveSearchSet.languageId = state.layout.language.current;
                saveSearchSet.currencyId = state.layout.currencies.currentCurrencyId;
                return [4 /*yield*/, effects_1.call(SaveSearchDialogSaga_1.saveSearchSetToRemote, saveSearchSet)];
            case 10:
                _a.sent();
                return [4 /*yield*/, effects_1.call(DetailCallSaga_1.getBuildingFollowState, name, state.detail.referringType)];
            case 11:
                existingSearchSetId = _a.sent();
                if (!existingSearchSetId) return [3 /*break*/, 13];
                return [4 /*yield*/, effects_1.put(DetailAction_1.default.setBuildingFollowingId(existingSearchSetId))];
            case 12:
                _a.sent();
                _a.label = 13;
            case 13: return [3 /*break*/, 0];
            case 14: return [2 /*return*/];
        }
    });
};
var watchPopRenderNoScroll = function () {
    var payload, state;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(DetailAction_1.default.setPopRender)];
            case 1:
                payload = (_a.sent()).payload;
                state = payload;
                if (!state) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.call(WindowApi_1.setNoScrollBody, true)];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, effects_1.call(WindowApi_1.setNoScrollBody, false)];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
var watchCheckNavBackUrl = function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(DetailAction_1.default.DETAIL_CHECK_NAV_BACK_URL)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.getLatestSearchFilterUrl)];
            case 2:
                url = _a.sent();
                if (!url)
                    return [3 /*break*/, 0];
                return [4 /*yield*/, effects_1.put(DetailAction_1.default.setNavBackUrl(url))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchShareClick = function () {
    var url, title, text, files, shareInfo, canWebShare, isMobile;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 11];
                return [4 /*yield*/, effects_1.take(ShareAction_1.default.ON_SHARE_CLICKED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getPropertyShareUrl)];
            case 2:
                url = _a.sent();
                return [4 /*yield*/, effects_1.select(getPropertyTitle)];
            case 3:
                title = _a.sent();
                return [4 /*yield*/, effects_1.select(getPropertyText)];
            case 4:
                text = _a.sent();
                return [4 /*yield*/, effects_1.select(getSomePropertyPhotos)];
            case 5:
                files = _a.sent();
                shareInfo = { files: files, url: url, title: title, text: text };
                return [4 /*yield*/, effects_1.call(WindowApi_1.checkCanWebShare)];
            case 6:
                canWebShare = _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.getIsMobile)];
            case 7:
                isMobile = _a.sent();
                if (!(!canWebShare || !isMobile)) return [3 /*break*/, 9];
                return [4 /*yield*/, effects_1.put(ShareAction_1.default.setShareActive(true))];
            case 8:
                _a.sent();
                return [3 /*break*/, 0];
            case 9: return [4 /*yield*/, effects_1.call(WindowApi_1.webShare, shareInfo)];
            case 10:
                _a.sent();
                return [3 /*break*/, 0];
            case 11: return [2 /*return*/];
        }
    });
};
var lazyLoadSlider = function () {
    var gallerySlider;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(WindowApi_1.getElementById, 'detailgallery-detail-slides')];
            case 1:
                gallerySlider = _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.lazyLoadImagesIn, gallerySlider)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchInit = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_DOM_LOADED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.fork(DetailCallSaga_1.checkFeatureOverflow)];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.fork(setIsSaved)];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.fork(setEnquireCurrent)];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.fork(setWatchStickyContact)];
            case 5:
                _a.sent();
                return [4 /*yield*/, effects_1.fork(setWatchStickyTop)];
            case 6:
                _a.sent();
                return [4 /*yield*/, effects_1.fork(setRecentlyViewed)];
            case 7:
                _a.sent();
                return [4 /*yield*/, effects_1.fork(setOnScrollInitSmallMap)];
            case 8:
                _a.sent();
                return [4 /*yield*/, effects_1.fork(lazyLoadSlider)];
            case 9:
                _a.sent();
                return [4 /*yield*/, effects_1.fork(GlobalCallSaga_1.initLazyLoad)];
            case 10:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchLogin = function () {
    var payload, user;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(UserAction_1.default.SET_USER_DONE)];
            case 1:
                payload = (_a.sent()).payload;
                user = payload;
                return [4 /*yield*/, effects_1.fork(setFollowState, user)];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.fork(setIsSaved)];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var rootDetailSagas = {
    rootPublicPageSagas: RootPublicPageSaga_1.rootPublicPageSagas,
    rootTrendsSagas: RootTrendsSaga_1.rootTrendsSagas,
    rootTransactionsSagas: RootTransactionsSaga_1.rootTransactionsSagas,
    mortgageSagas: MortgageSagas_1.mortgageSagas,
    nearbySagas: NearbySaga_1.nearbySagas,
    watchOnItemClicked: ResultItemSaga_1.watchOnItemClicked,
    watchOnResultEnquireClicked: ResultItemSaga_1.watchOnResultEnquireClicked,
    detailGallerySaga: detailGallerySaga,
    detailPropertyPhotoGallerySaga: detailPropertyPhotoGallerySaga,
    detailFloorPlanGallerySaga: detailFloorPlanGallerySaga,
    placeAvailableSagas: PlaceAvailableSaga_1.placeAvailableSagas,
    videoSagas: VideoSaga_1.videoSagas(VideoSagaSelector_1.selector),
    sortToggleSaga: sortToggleSaga,
    watchInit: watchInit,
    watchLogin: watchLogin,
    watchClosePopup: watchClosePopup,
    watchGalleryGridItemClick: watchGalleryGridItemClick,
    watchPopupMenuItemClick: watchPopupMenuItemClick,
    watchVrClick: watchVrClick,
    watchNearbyClick: watchNearbyClick,
    watchMyPlaceClick: watchMyPlaceClick,
    watchPropertyClick: watchPropertyClick,
    watchPopRender: watchPopRender,
    watchEnquireClick: watchEnquireClick,
    watchWhatsAppClick: watchWhatsAppClick,
    watchBackClick: watchBackClick,
    watchOnFavClick: watchOnFavClick,
    watchOnSaveBuildingSaga: watchOnSaveBuildingSaga,
    watchOnSaveDistrictSaga: watchOnSaveDistrictSaga,
    watchBuildingFollowClicked: watchBuildingFollowClicked,
    watchDistrictFollowClicked: watchDistrictFollowClicked,
    watchBuildingUnfollowClicked: watchBuildingUnfollowClicked,
    watchDistrictUnfollowClicked: watchDistrictUnfollowClicked,
    watchPopRenderNoScroll: watchPopRenderNoScroll,
    watchCheckNavBackUrl: watchCheckNavBackUrl,
    watchLayoutEnquireClick: watchLayoutEnquireClick,
    watchLayoutWhatsAppClick: watchLayoutWhatsAppClick,
    watchShareClick: watchShareClick,
};
exports.rootDetailSagas = rootDetailSagas;
